import {Card, ListGroup, Table} from "react-bootstrap";
import {HistoryProduct} from "../Product/HistoryProduct";
import {useEffect, useState} from "react";
import {GetDateFromString} from "../../common/Helpers/jsHelpers";
import Accordion from 'react-bootstrap/Accordion';
import {React, useRef} from "react";
import {ConfirmPopup} from "primereact/confirmpopup";
import { Toast } from 'primereact/toast';
import style from './SalesOrderNew.module.css'
import {salesOrderAPI} from "../../api/api";
import {useNavigate} from "react-router-dom";
import {useCartContext} from "../../Context/CartContext";
import {Button} from "primereact/button";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export const SalesOrderNew = ({
                               id,
                               crmId,
                               number,
                               productList,
                               data,
                               totalDeltaAmount,
                               salesOrderStateCode,
                               actualShipmentDate,
                               requestDeliveryBy,
                               shippingMethodCodeDescription,
                               accountingTypeCodeDescription,
                               addressDeliveryIdName,
                               contactShippingIdName,
                               loadSalesOrder,
                               isDebtOverdue,
                               toast
                           }) => {
    const [products, setProducts] = useState([]);
    const [date, setDate] = useState("");
    const [requestDeliveryByDate, setRequestDeliveryByDate] = useState("");
    const [actualShipmentByDate, setActualShipmentByDate] = useState("");
    const [orderSum, setOrderSum] = useState(0.00);
    const {setInitCart} = useCartContext();

    const cancelButton = useRef(null);
    const [visible, setVisible] = useState(false);

    const navigate = useNavigate()

    const orderSumHandler = (list) => {
        let sum = 0.00;
        for (const element of list) {
            sum += element.Tax;
        }
        setOrderSum(sum.toFixed(2));
    }

    const repeatOrder = async () => {
        debugger
        const {data} = await salesOrderAPI.repeatOrder(id)
        const result = JSON.parse(data);
        if (result.isSucccess) {
            setInitCart().then();
            navigate("/cart")
        } else {

        }
    }

    const cancelOrder = async () => {
        debugger
        const cancelModel = {SalesOrderId: crmId};

        const {data} = await salesOrderAPI.cancelOrder(cancelModel)
        const result = JSON.parse(data);
        if(!result.isSucccess)
        {
            toast.current.clear();
            toast.current.show({
                severity: 'error',
                summary: 'Помилка',
                clearPrevious: true,
                detail: 'Не вдалося скасувати замовлення. Причина:  ' + result.message,
                life: 5000
            });
        }
        loadSalesOrder().then();
    }

    const setDateFormString = () => {
        if (requestDeliveryBy) {
            setRequestDeliveryByDate(GetDateFromString(requestDeliveryBy))
        }
        if(actualShipmentDate){
            setActualShipmentByDate(GetDateFromString(actualShipmentDate))
        }
        if (data) {
            setDate(GetDateFromString(data))
        }
    }
    
    const accept = () => {
        cancelOrder().then();
        setVisible(false);
    };

    const reject = () => {
        setVisible(false);
    };

    const onHide =() =>{
        setVisible(false);
    }
    const onShow = () =>{
        setVisible(true);
        setTimeout(() =>{
            setVisible(false);
        },5000)
    }

    const pricePerUnitBodyTemplate = (rowData) => {
        return (rowData.PricePerUnit.toLocaleString('uk-UA', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }));
    };

    const taxBodyTemplate = (rowData) => {
        return (rowData.Tax.toLocaleString('uk-UA', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }));
    };

    

    const renderFooter = () => {
        return (
            <div style={{float: 'right', margin:'5px'}}>
                <Button style={{marginRight:'5px', padding:'5px 10px'}} severity="danger" label="Так" icon="pi pi-check" onClick={accept} />
                <Button style={{padding:'5px 10px'}} label="Ні" icon="pi pi-times" onClick={reject} className="p-button-secondary" />
            </div>
        );
    };

    const invoiceDebtSchema = () => {
        if(totalDeltaAmount > 0 && isDebtOverdue){
            return (
                <div style={{color: "red"}}>{totalDeltaAmount.toLocaleString('uk-UA', {style: 'currency', currency: 'UAH', currencyDisplay: 'symbol'})}</div>
            )
        }
        else if(totalDeltaAmount > 0 && !isDebtOverdue){
            return(
                <div style={{color: "#1462d6"}}>{totalDeltaAmount.toLocaleString('uk-UA', {style: 'currency', currency: 'UAH', currencyDisplay: 'symbol'})}</div>
            )
        }
        else if(totalDeltaAmount === 0){
            return(
                <div style={{color: "green"}}>Відсутня</div>
            )
        }
    }

    useEffect(() => {
        setDateFormString();
    }, [actualShipmentDate, data, requestDeliveryBy])

    useEffect(() => {
        if (productList.length !== 0) {
            setProducts(productList);
            orderSumHandler(productList)
        }
    }, [productList])

    if (productList.length === 0) {
        return (<div></div>)
    }
    return (

        <>
            <div className={style.info}>
                             <span style={{marginBottom: '5px'}}>
                                    <span className={style.gray}> Спосіб доставки:</span>
                                    <span className={style.infoDetail}>{shippingMethodCodeDescription}</span>
                             </span>
                <span style={{marginBottom: '5px'}}>
                                    <span className={style.gray}> Адреса відвантаження:</span>
                                    <span className={style.infoDetail}>{addressDeliveryIdName}</span>
                                </span>
                <span style={{marginBottom: '5px'}}>
                                    <span className={style.gray}> Спосіб оплати:</span>
                                    <span className={style.infoDetail}>{accountingTypeCodeDescription}</span>
                                </span>
                {actualShipmentByDate ?
                    <span style={{marginBottom: '5px'}}>
                                        <span className={style.gray}> Фактична дата відвантаження:</span>
                                        <span className={style.infoDetail}>{actualShipmentByDate}</span>
                                    </span>
                    : requestDeliveryByDate ?
                        <span style={{marginBottom: '5px'}}>
                                            <span className={style.gray}> Очікувана дата відвантаження:</span>
                                            <span className={style.infoDetail}>{requestDeliveryByDate}</span>
                                        </span>
                        : null
                }

                <span style={{marginBottom: '5px'}}>
                                    <span className={style.gray}> Контакт для доставки:</span>
                                    <span className={style.infoDetail}>{contactShippingIdName}</span>
                                </span>
            </div>

                        <div className="card">
                            <DataTable value={products} stripedRows  showGridlines  >
                                <Column field="ProductName" header="Товар" sortable ></Column>
                                <Column field="Quantity"  header="Кількість" sortable ></Column>
                                <Column field="PricePerUnit"  body={pricePerUnitBodyTemplate}   dataType="numeric" header="Ціна" sortable ></Column>
                                <Column field="Tax" body={taxBodyTemplate} dataType="numeric" header="Сума" sortable ></Column>
                            </DataTable>
                        </div>

                        {salesOrderStateCode == 1 ?
                                <div style={{display:"flex", justifyContent:"flex-end", paddingTop: '10px'}}>
                                    <Button ref={cancelButton} onClick={onShow} icon="pi pi-trash" style={{borderRadius:'5px'}}
                                    severity="danger">Скасувати замовлення</Button>
                                </div>
                        : null}
                        <ConfirmPopup target={cancelButton.current} key={id+number} dismissable={false} footer={renderFooter} visible={visible} onHide={onHide}
                                                        message={"Ви впевнені, що хочете скасувати замовлення?"} icon="pi pi-exclamation-triangle" />
                <Card.Text>
                </Card.Text>
        </>
        )
}
